import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import {buildUrl} from './jsonHttpClient';

export class GpkgHttpClient implements HttpClient {
  constructor(
    private readonly baseUrl: string,
    private readonly getToken?: () => Promise<string | undefined>,
  ) {}

  async get<Response>(path: string): Promise<Response> {
    const headers: {[p: string]: string} = {};
    if (this.getToken) {
      headers.Authorization = `Bearer ${await this.getToken()}`;
    }
    const url = buildUrl(this.baseUrl, path);
    const response = await fetch(url, {
      method: 'GET',
      headers: {
        ...headers,
        'Content-Type': 'application/geopackage+sqlite3',
        Accept: 'application/geopackage+sqlite3',
      },
    });
    return response.blob() as Promise<Response>;
  }

  async delete(_path: string): Promise<void> {
    throw Error('Not implemented');
  }

  async patch<Request, Response>(_path: string, _body: Partial<Request>): Promise<Response> {
    throw Error('Not implemented');
  }

  async post<Request, Response>(_path: string, _body: Request): Promise<Response> {
    throw Error('Not implemented');
  }

  async put<Request, Response>(_path: string, _body: Request): Promise<Response> {
    throw Error('Not implemented');
  }
}
